export default "__VITE_ASSET__czQSLKnh__"